var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notes-editor"},[_c('quill-editor',{staticClass:"quill-editor-full",attrs:{"options":_vm.editorOptions,"disabled":_vm.readOnly},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }